import type { InputGroupDesignTokens } from '@primeuix/themes/types/inputgroup';

 export default {
    addon: {
        color: "{form.field.icon.color}",
        padding: "0.5rem",
        minWidth: "2.5rem",
        background: "{form.field.background}",
        borderColor: "{form.field.border.color}",
        borderRadius: "{form.field.border.radius}"
    }
} satisfies InputGroupDesignTokens;